import { ObjectLiteral } from '@prophecy/interfaces/generic';
import queryString from 'query-string';

import { ReplayDetails } from '../data/apis/types';

const REPLAY_WINDOW_KEY = '__prophecy-replay-token';
export const REPLAY_TOKEN_KEY = 'replay-token';

const windowStore = window as ObjectLiteral;

interface ReplayToken {
  key: string;
  hasDirectAccess?: boolean;
  replayDetails?: ReplayDetails['replayDetails'];
  loggedInUserID?: string;
  get: () => string | null;
  set: (value: string) => void;
  delete: () => void;
}

export const replayToken: ReplayToken = {
  key: REPLAY_TOKEN_KEY,
  get() {
    return windowStore[REPLAY_WINDOW_KEY] as string;
  },
  set(value: string) {
    windowStore[REPLAY_WINDOW_KEY] = value;
  },
  delete() {
    windowStore[REPLAY_WINDOW_KEY] = null;
  }
};

export function addReplayTokenQuery(url: string) {
  const token = replayToken.get();
  if (!token) return url;
  const tokenQuery = queryString.stringify({ [REPLAY_TOKEN_KEY]: token });
  return url.includes('?') ? `${url}&${tokenQuery}` : `${url}?${tokenQuery}`;
}

export const isReplayMode = () => {
  return Boolean(replayToken.get());
};
